import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { Headline1, Headline4 } from 'components/ui/Typography'
import HorizontalWrapper from '../HorizontalWrapper'

import s from './Intro.module.scss'
const cn = classNames.bind(s)

const Intro = ({ title, tagline }) => {
  return (
    <HorizontalWrapper className={cn('smallMarginOnMobile')}>
      <div className={cn('inner')}>
        <div className={cn('tagline')}>{tagline && <Headline1 as="h2">{tagline[0].text}</Headline1>}</div>
        <div className={cn('title')}>{title && <Headline4 as="h1">{title[0].text}</Headline4>}</div>
      </div>
    </HorizontalWrapper>
  )
}

Intro.propTypes = {
  title: PropTypes.array,
  tagline: PropTypes.array,
}

export default Intro
